import {LevelData} from "./models/levelData";
import RoomTile from "./RoomTile";
import {useApp} from "./appContext";

function RoomsView() {
    const {levels} = useApp();

    return (
        <div className={'layout vertical gap flex-grow'} style={{paddingTop: 20}}>
            <div className={'gridView'}>
                {levels.map((level: LevelData, index: number) => {
                    return <RoomTile key={index} level={level}/>
                })}
            </div>
        </div>
    )
}

export default RoomsView;
